// extracted by mini-css-extract-plugin
export default {"menu":"styles_menu__lWhZB","menu__options":"styles_menu__options__Ki+qR"};